// The visitor's own try-it episode, made once and reused: its id is remembered in this browser's localStorage. If the
// remembered one is gone (deleted, or the server was reset), a fresh copy of the demo template is made instead.
// Making it also copies the demo's characters into the visitor's library, so the library is loaded again before the
// demo is drawn (a first visit loaded it empty, and the demo can't be drawn without its characters).
import { api } from "../api";
import { setLibrary } from "../../library/store";

const KEY = "sketchy-demo-episode";
const remembered = () => { try { return localStorage.getItem(KEY); } catch { return null; } };
const remember = (id: string) => { try { localStorage.setItem(KEY, id); } catch {} };

// One look-up at a time: a second caller while the first is still going (React runs effects twice in StrictMode)
// shares its answer, instead of making a second demo episode.
let pending: Promise<string> | null = null;
export function demoEpisodeId(): Promise<string> {
  pending ??= find().finally(() => { pending = null; });
  return pending;
}

async function find(): Promise<string> {
  const old = remembered();
  if (old) { try { await api.getEpisode(old); return old; } catch {} }
  const id = (await api.demo()).id;
  setLibrary(await api.library());
  remember(id);
  return id;
}
